import React from 'react';
import mapImg from '../../images/map.png';
import mailImg from '../../images/contact-mail.png';
import phoneImg from '../../images/contact-phone.png';
import locationImg from '../../images/contact-location.png';
import axios from 'axios';
import { API_BASE_URL } from '../../apiConfig';

export default class MobContact extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            name: '',
            success: '',

            email: '',
            phoneNo: '',
            yourMsg: '',
            formErrors: { name: '', email: '', phoneNo: '', yourMsg: '' },
            nameValid: false,
            emailValid: false,
            phoneNoValid: false,
            yourMsgValid: false,
            formValid: false
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.validateField = this.validateField.bind(this);
        this.validateForm = this.validateForm.bind(this);
    }

    handleChange(e) {
        const name = e.target.name;
        const value = e.target.value;
        this.setState({ [name]: value }, () => { this.validateField(name, value) });
    }
    validateField(fieldName, value) {
        let fieldValidationErrors = this.state.formErrors;
        let nameValid = this.state.nameValid;
        let emailValid = this.state.emailValid;
        let phoneNoValid = this.state.phoneNoValid;
        let yourMsgValid = this.state.yourMsgValid;

        switch (fieldName) {
            case 'name':
                nameValid = value.length >= 1;
                fieldValidationErrors.name = nameValid ? '' : 'This field is required';
                break;
            case 'email':
                emailValid = value.match(/^([\w.%+-]+)@([\w-]+\.)+([\w]{2,})$/i);
                fieldValidationErrors.email = emailValid ? '' : ' is invalid';
                break;
            case 'phoneNo':
                phoneNoValid = value.length >= 1;
                fieldValidationErrors.company = phoneNoValid ? '' : 'This field is required';
                break;
            case 'yourMsg':
                yourMsgValid = value.length >= 1;
                fieldValidationErrors.Idea = yourMsgValid ? '' : 'This field is required';
                break;
            default:
                break;
        }
        this.setState({
            formErrors: fieldValidationErrors,
            nameValid: nameValid,
            emailValid: emailValid,
            phoneNoValid: phoneNoValid,
            yourMsgValid: yourMsgValid,
        }, this.validateForm);
    }
    validateForm() {
        this.setState({ formValid: this.state.nameValid && this.state.emailValid && this.state.phoneNoValid && this.state.yourMsgValid });
    }
    handleSubmit(event) {
        event.preventDefault();
        this.setState({
            success : 'Message Sending...' 
        })
        const data = {
            name: this.state.name,
            admin_email: this.state.email,
            mobile: this.state.phoneNo,
            msg: this.state.yourMsg
        }
        axios.post(`${API_BASE_URL}/mail`, data).then((res) => {
            this.setState({
                success : 'Sent !',

                success : res.data 
            })

        });
    }
    styles = {
        contactWrapper: {
            boxShadow: '0px 0px 6px rgba(0, 0, 0, 0.25)',
            borderRadius: ' 12px',
        },
        input: {
            width: '100%',
            height: '44px',
            border: 'none',
            boxShadow: 'inset 0px 0px 4px rgba(0, 0, 0, 0.25)',
            borderRadius: '12px',
            paddingLeft:'10px',

        },
        label: {
            font: '400 1rem var(--fontSSP)'
        },
        textarea: {
            width: '100%',
            height: '167px',
            resize: 'none',
            border: 'none',
            boxShadow: 'inset 0px 0px 4px rgba(0, 0, 0, 0.25)',
            borderRadius: '12px',
            paddingLeft:'10px',
            paddingTop:'10px',
        },
        star: {
            color: '#CC2229'
        }
    };

    render() {
        return (
            <div style={{ margin: '0 auto', marginBottom: '80px', padding: ".5rem" }}>
                <div style={this.styles.contactWrapper}>
                    <div style={{
                        background: 'var(--blue)', color: 'white', width: '100%', height: 'fit-content',
                        padding: '2rem 3rem', boxSizing: 'border-box', borderRadius: 15
                    }}>
                        <h2 style={{ font: '700 1rem var(--fontSSP)', textAlign: 'center', margin: '0 0 3rem 0' }}>Get in touch with us to join the greatest cricket league <br />
                            and hit some big sixes!
                        </h2>
                        <div style={{ display: 'flex', marginBottom: '2rem' }}>
                            <div style={{ marginRight: '2rem' }}><img src={mailImg} alt="" /></div>
                            <div>
                                <p style={{ font: '400 1rem var(--fontSSP)', margin: 0 }}>Our team will ping you within hours</p>
                                <p style={{ font: '300 .9rem var(--fontSSP)', margin: 0 }}> hello@btcluk.com</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', marginBottom: '2rem' }}>
                            <div style={{ marginRight: '2rem' }}><img src={phoneImg} alt="" /></div>

                            <div>
                                <p style={{ font: '400 1rem var(--fontSSP)', margin: 0 }}>Mon - Fri from 9AM to 3PM</p>
                                <p style={{ font: '300 .9rem var(--fontSSP)', margin: 0 }}>020 8150 5667</p>
                            </div>
                        </div>
                        <div style={{ display: 'flex', marginBottom: '2rem' }}>
                            <div style={{ marginRight: '2rem' }}><img src={locationImg} alt="" /></div>

                            <div>
                                <p style={{ font: '400 1rem var(--fontSSP)', margin: 0 }}>Shake your hand with us at our HQ</p>
                                <p style={{ font: '300 .9rem var(--fontSSP)', margin: 0 }}>British Tamils Cricket League (BTCL)</p>
                                <p style={{ font: '300 .9rem var(--fontSSP)', margin: 0 }}>14 Elm Road , Chessington</p>
                                <p style={{ font: '300 .9rem var(--fontSSP)', margin: 0 }}>Surrey KT9 1AW</p>
                            </div>
                        </div>
                        <a target='blank' href="https://www.google.com/maps/uv?pb=!1s0x48760a6aa0a2d8ff%3A0xd32e17d4b62600d!3m1!7e115!4s%2Fmaps%2Fplace%2FBritish%2BTamils%2BCricket%2BLeague%2B(BTCL)%2B14%2BElm%2BRoad%2B%2C%2BChessington%2BSurrey%2BKT9%2B1AW%2F%4051.36765%2C-0.3059016%2C3a%2C75y%2C111.51h%2C90t%2Fdata%3D*213m4*211e1*213m2*211ssKeIabtNRn5Gl9dMu9rO0w*212e0*214m2*213m1*211s0x48760a6aa0a2d8ff%3A0xd32e17d4b62600d%3Fsa%3DX!5sBritish%20Tamils%20Cricket%20League%20(BTCL)%2014%20Elm%20Road%20%2C%20Chessington%20Surrey%20KT9%201AW%20-%20Google%20Search!15sCgIgAQ&imagekey=!1e2!2ssKeIabtNRn5Gl9dMu9rO0w&hl=en&sa=X&ved=2ahUKEwjE1tTZyrr_AhXhXGwGHYNFDLoQpx96BAg_EAU"> <img src={mapImg} alt="" style={{}} width="100%" /></a>
                    </div>
                    <div style={{ padding: "2rem" }}>
                        <form onSubmit={this.handleSubmit}>
                            <div>
                                <label style={this.styles.label}>Full name<sup style={this.styles.star}>*</sup></label><br />
                                <input style={this.styles.input} type="text" id="name" name="name" value={this.state.name} onChange={this.handleChange} />
                            </div>
                            <p>{this.state.formErrors.name}</p>
                            <div>
                                <label style={this.styles.label}>Phone number<sup style={this.styles.star}>*</sup></label><br />
                                <input style={this.styles.input} type="text" id="phoneNo" name="phoneNo" value={this.state.company} onChange={this.handleChange} />
                            </div>
                            <p>{this.state.formErrors.company}</p>
                            <div>
                                <label style={this.styles.label}>Email<sup style={this.styles.star}>*</sup></label><br />
                                <input style={this.styles.input} type="email" name="email" id="email" value={this.state.email} onChange={this.handleChange} />
                            </div>
                            <p>{this.state.formErrors.email}</p>
                            <div>
                                <label style={this.styles.label}>Your message<sup style={this.styles.star}>*</sup></label><br />
                                <textarea style={this.styles.textarea} id="des-your-idea" name="yourMsg" value={this.state.yourMsg} onChange={this.handleChange} ></textarea>
                            </div>
                            <p>{this.state.formErrors.Idea}</p>
                            <div style={{ textAlign: 'center' }}>
                            <p  style={{ color:'green',fontSize:'20px',font: '20 1rem var(--fontSSP)' }} > { this.state.success}</p>

                                <div><input style={{
                                    backgroundColor: "var(--yellow)", color: 'white', border: 'none', padding: '.3rem 2rem', borderRadius: "1rem", font: '400 1rem var(--fontSSP)', cursor: 'pointer'
                                }} disabled={!this.state.formValid} type="submit" value="Submit" /></div>
                            </div>
                        </form>
                    </div>

                </div>
            </div >
        );
    }
}